<template>
  <section class="notification">
    <div class="columns">
      <div class="column">
        <span class="title is-5">{{ title }}</span>
      </div>
    </div>

    <template v-if="modifiedCodes.length > 0">
      <div class="tags">
        <ShortCodeTags
          :code="code"
          v-for="(code, index) of modifiedCodes"
          :key="index"
        >
          <template v-slot:actions="code">
            <div class="ShortCode">
              <div @click="insertShortCode(code.code)">
                <span class="icon is-small ">
                  <i
                    class="mdi mdi-variable"
                    v-if="code.code.type.typeName === 'variable'"
                  ></i>
                  <i
                    class="mdi mdi-sigma"
                    v-if="code.code.type.typeName === 'value'"
                  ></i>
                  <i
                    class="mdi mdi-table"
                    v-if="code.code.type.typeName === 'table'"
                  ></i>
                  <i
                    class="mdi mdi-poll"
                    v-if="code.code.type.typeName === 'chart'"
                  ></i>
                </span>
                <span v-if="code.code.id.length > 20">
                  <b-tooltip
                    :label="code.code.id.substring(1)"
                    position="is-top"
                  >
                    {{ code.code.id.substring(0, 20) }}
                    ...
                  </b-tooltip>
                </span>
                <span v-else>{{ code.code.id }} </span>
              </div>
              <b-tooltip label="Изменить" position="is-top" class="settings">
                <span class="icon is-small" @click="editShortCode(code.code)">
                  <i class="mdi mdi-settings"></i>
                </span>
              </b-tooltip>
              <b-tooltip label="Удалить" position="is-top" class="settings">
                <span class="icon is-small" @click="deleteShortCode(code.code)">
                  <i class="mdi mdi-close"></i>
                </span>
              </b-tooltip>
            </div>
          </template>
        </ShortCodeTags>
      </div>
    </template>

    <slot />
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {
    ShortCodeTags: () =>
      import(
        /* webpackChunkName: "ShortCodeTags" */ "@/components/shared/document/ShortCodeTags"
      )
  },
  props: {
    codes: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    deleteShortCode(code) {
      this.$emit("deleteShortCode", code);
    },
    editShortCode(code) {
      this.$emit("editShortCode", code);
    },
    insertShortCode(code) {
      this.$root.$emit("pushShortCode", code);
    }
  },
  computed: {
    modifiedCodes() {
      return this.codes.map(el => {
        const { name, ...rest } = el;

        return {
          id: "_" + el.name,
          ...rest
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.ShortCode {
  display: flex;
  cursor: pointer;

  & > * {
    display: block;
  }
}
.settings {
  margin-left: 0.2rem;
  background-color: rgba(black, 0.2);
  width: 16px;
  height: 16px;
  border-radius: 10rem;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: rgba(black, 0.3);
  }

  &:last-child {
    margin-right: -0.3rem;
  }
}
</style>
